import { FC, useState } from 'react';
import { Button, Popover } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import FlexBox from '../../../../atoms/FlexBox';
import EmailUploader from './EmailUploader';
import EmailPopoverForm, { EmailFormData } from './EmailPopoverForm';
import PhoneCallPopoverForm, { PhoneCallFormData } from './PhoneCallPopoverForm';
import { ParentUploadFunction } from '../parser/communicationParser';

interface LogTableControlsProps {
    disabled: boolean;
    onAddEmail: (data: EmailFormData) => boolean | Promise<boolean>;
    onAddPhone: (data: PhoneCallFormData) => boolean | Promise<boolean>;
    onEmailParsed: (emailData: any) => void;
    uploadAttachmentFunction: ParentUploadFunction;
    parentDocId?: string;
}

const LogTableControls: FC<LogTableControlsProps> = ({
    disabled,
    onAddEmail,
    onAddPhone,
    onEmailParsed,
    uploadAttachmentFunction,
    parentDocId,
}) => {
    const [addEmailOpen, setAddEmailOpen] = useState(false);
    const [addPhoneOpen, setAddPhoneOpen] = useState(false);

    const handleAddEmail = async (data: EmailFormData) => {
        const success = await onAddEmail(data);
        if (success) {
            setAddEmailOpen(false);
        }
        return success;
    };

    const handleAddPhone = async (data: PhoneCallFormData) => {
        const success = await onAddPhone(data);
        if (success) {
            setAddPhoneOpen(false);
        }
        return success;
    };

    if (disabled) {
        return null;
    }

    return (
        <FlexBox stretch wrap className='no-print' gap={2}>
            <EmailUploader
                disabled={disabled || !parentDocId}
                onEmailParsed={onEmailParsed}
                uploadAttachmentFunction={uploadAttachmentFunction}
                parentDocId={parentDocId}
            />
            <Popover
                content={
                    <EmailPopoverForm
                        onSave={handleAddEmail}
                        onCancel={() => setAddEmailOpen(false)}
                        disabled={disabled}
                    />
                }
                trigger="click"
                open={addEmailOpen}
                onOpenChange={setAddEmailOpen}
            >
                <Button
                    type="text"
                    icon={<MailOutlined />}
                    aria-label="Add Email"
                    size='large'
                >
                    Add Email
                </Button>
            </Popover>
            <Popover
                content={
                    <PhoneCallPopoverForm
                        onSave={handleAddPhone}
                        onCancel={() => setAddPhoneOpen(false)}
                        disabled={disabled}
                    />
                }
                trigger="click"
                open={addPhoneOpen}
                onOpenChange={setAddPhoneOpen}
            >
                <Button
                    type="text"
                    icon={<PhoneOutlined />}
                    aria-label="Add Call"
                    size='large'
                >
                    Add Call
                </Button>
            </Popover>
        </FlexBox>
    );
};

export default LogTableControls;

